var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "selectableItem",
      class: { selectedToolItem: _vm.objectTypeIsSelected },
      on: {
        click: function($event) {
          return _vm.selectItem(_vm.currentLayer)
        },
        contextmenu: function($event) {
          $event.preventDefault()
          return _vm.toggleOptionsMenu(_vm.objectType)
        }
      }
    },
    [
      _c(
        _vm.objectTypeIsSelected
          ? _vm.currentLayer.filledIcon
          : _vm.currentLayer.icon,
        {
          tag: "component",
          staticClass: "toolsSVG",
          class: { filled: _vm.objectTypeIsSelected }
        }
      ),
      _vm._v(" "),
      _c(
        "v-icon",
        {
          staticClass: "options-arrow",
          attrs: {
            size: "16",
            color: _vm.objectTypeIsSelected ? "accent" : "primary"
          }
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.listIsOpen ? "arrow_drop_up" : "arrow_drop_down") +
              "\n  "
          )
        ]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "svgTextToolbar" }, [
        _vm._v(_vm._s(_vm.label))
      ]),
      _vm._v(" "),
      _vm.currentLayer.instructions && _vm.objectTypeIsSelected
        ? _c("instructions-tooltip", {
            attrs: {
              icon: _vm.currentLayer.filledIcon,
              instructions: _vm.currentLayer.instructions
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("item-options-menu", {
        attrs: {
          "is-open": _vm.listIsOpen,
          options: _vm.options,
          "current-layer": _vm.currentLayer.layer
        },
        on: { select: _vm.activateLayer }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45aa5067", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45aa5067","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Toolbars/CreateObjects/ItemWithOptions.vue
// module id = null
// module chunks = 